var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isTherapist)?_c('v-col',{staticClass:"mt-4",attrs:{"cols":"10","md":"10","lg":"8","xl":"8"}},[_c('p',{staticClass:"headline text-center primary--text mb-0"},[_vm._v(" "+_vm._s(_vm.$t('therapist.patients'))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }